// Wijzigingen van het lidmaatschap: opzegging, overstap en een tweede club (fase 6).
//
// Eén bouwsteen voor drie plekken: de eigen omgeving van een lid (aanvragen en
// volgen), het verzoek zelf (de kaart met wie al heeft ingestemd) en het
// verzoekenscherm van clubs en bond (wat wacht op hun besluit). De database
// bepaalt wie wat mag (tests/rls/30_opzegging_overstap.sql); dit scherm legt voor.
import { t, locale } from '../lib/i18n.js';
import { esc } from '../lib/format.js';
import { toast } from './toast.js';

const datum = iso => {
  if (!iso) return '';
  const d = new Date(iso.length > 10 ? iso : iso + 'T00:00:00Z');
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString(locale(), { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
};
const vandaag = () => new Date().toISOString().slice(0, 10);
const klein = tekst => `<p style="font-size:12px;color:var(--text-3)">${esc(tekst)}</p>`;
const knop = (actie, icoon, tekst, soort = 'btn-default', extra = '') =>
  `<button type="button" class="btn ${soort} btn-sm" data-lm="${actie}" ${extra}><i class="ti ti-${icoon}"></i> ${esc(tekst)}</button>`;
const BADGE = { open: 'badge-blue', akkoord: 'badge-teal', uitgevoerd: 'badge-green', afgewezen: 'badge-grey', verlopen: 'badge-grey' };
const ROL_ICOON = { wacht: 'hourglass', akkoord: 'circle-check', bezwaar: 'alert-triangle' };
// Stilzwijgend akkoord van de bond, voor de uitleg in het aanvraagvenster.
export const stilAttr = r => (r?.stilzwijgen ? ' data-stil="1"' : '');

export function lidmFout(e) {
  const m = String(e?.message || e || '').match(/lidmaatschap:([a-z_]+)/);
  return m ? t('lidm.fout.' + m[1]) : t('alg.fout', { melding: e?.message || String(e) });
}

// ── Vensters ───────────────────────────────────────────────────────────────
function venster(inhoud, knopTekst, lees, eis = false) {
  return new Promise(klaar => {
    document.getElementById('lidmModal')?.remove();
    const m = document.createElement('div');
    m.className = 'modal-overlay open';
    m.id = 'lidmModal';
    m.innerHTML = `<div class="modal" style="max-width:520px">${inhoud}
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-lm-m="annuleer">${esc(t('alg.annuleren'))}</button>
        <button type="button" class="btn btn-primary" data-lm-m="ok">${esc(knopTekst)}</button>
      </div></div>`;
    document.body.appendChild(m);
    const sluit = uit => { m.remove(); klaar(uit); };
    m.addEventListener('click', e => {
      if (e.target === m || e.target.closest('[data-lm-m="annuleer"]')) return sluit(null);
      if (!e.target.closest('[data-lm-m="ok"]')) return;
      const uit = lees(m);
      // Een verplichte toelichting: het venster blijft open tot er iets staat.
      if (eis && !uit) { m.querySelector('textarea')?.focus(); return; }
      sluit(uit);
    });
  });
}
const kop = titel => `<div class="modal-header"><span class="modal-title">${esc(titel)}</span>
  <button type="button" class="btn-icon" data-lm-m="annuleer" title="${esc(t('alg.sluiten'))}"><i class="ti ti-x"></i></button></div>`;

// Een toelichting vragen (bezwaar, besluit van de bond).
function vraagToelichting({ titel, uitleg, label, knopTekst }) {
  return venster(`${kop(titel)}<div class="modal-body">
      <p style="font-size:13px;color:var(--text-2);margin-bottom:12px">${esc(uitleg)}</p>
      <div class="form-group"><label class="form-label">${esc(label)}</label>
        <textarea class="form-input" name="lmToelichting" rows="3" maxlength="2000"></textarea></div></div>`,
    knopTekst, m => m.querySelector('[name="lmToelichting"]').value.trim(), true);
}

// Een wijziging aanvragen voor dit lidmaatschap. Geeft true als het verzoek is ingediend.
export async function vraagWijziging(client, relationId, soort, opties = {}) {
  let clubs = [];
  if (soort !== 'opzegging') {
    const { data, error } = await client.rpc('clubs_voor_overstap', { p_relation: relationId });
    if (error) { toast(lidmFout(error), 'error'); return false; }
    clubs = data || [];
  }
  // Zonder stilzwijgend akkoord (standaard) volgt na 14 dagen een herinnering en beslist de bond.
  const uitleg = opties.stilzwijgen && soort !== 'tweede_club' ? 'lidm.aanvraag.uitlegStil.' : 'lidm.aanvraag.uitleg.';
  const uit = await venster(`${kop(t('lidm.aanvraag.titel.' + soort))}<div class="modal-body">
      <p style="font-size:13px;color:var(--text-2);margin-bottom:12px">${esc(t(uitleg + soort))}</p>
      ${soort !== 'opzegging' ? `<div class="form-group"><label class="form-label">${esc(t('lidm.veld.club'))} *</label>
        <select class="form-input" name="lmClub"><option value="">${esc(t('leden.club.kies'))}</option>
          ${clubs.map(c => `<option value="${esc(c.id)}">${esc(c.naam)}${c.plaats ? ' (' + esc(c.plaats) + ')' : ''}</option>`).join('')}</select></div>` : ''}
      <div class="form-group"><label class="form-label">${esc(t('lidm.veld.datum'))}</label>
        <input class="form-input" type="date" name="lmDatum" value="${vandaag()}" min="${vandaag()}"></div>
      <div class="form-group"><label class="form-label">${esc(t('lidm.veld.toelichting'))}${opties.toelichtingVerplicht ? ' *' : ''}</label>
        <textarea class="form-input" name="lmToelichting" rows="3" maxlength="4000"></textarea></div></div>`,
    t('lidm.knop.indienen'), m => ({
      club: m.querySelector('[name="lmClub"]')?.value || null,
      datum: m.querySelector('[name="lmDatum"]').value || null,
      toelichting: m.querySelector('[name="lmToelichting"]').value.trim() || null,
    }));
  if (!uit) return false;
  if (soort !== 'opzegging' && !uit.club) { toast(t('lidm.fout.club_onbekend'), 'error'); return false; }
  if (opties.toelichtingVerplicht && !uit.toelichting) { toast(t('lidm.fout.toelichting_nodig'), 'error'); return false; }
  const { error } = await client.rpc('lidmaatschap_wijziging_aanvragen', {
    p_relation: relationId, p_actie: soort, p_naar_club: uit.club, p_datum: uit.datum, p_toelichting: uit.toelichting, p_als: opties.als || null });
  if (error) { toast(lidmFout(error), 'error'); return false; }
  toast(t('lidm.ingediend'), 'success');
  return true;
}

// ── De kaart van een wijziging ─────────────────────────────────────────────
export function actieKaartHtml(a) {
  const rollen = (a.rollen || []).map(r => {
    const stil = r.status === 'akkoord' && r.stilzwijgend ? ' · ' + t('lidm.rol.stilzwijgend')
      : r.status === 'wacht' && r.herinnerd_op ? ' · ' + t('lidm.rol.herinnerd', { datum: datum(r.herinnerd_op) })
      : r.status === 'wacht' && r.stilzwijgend_vanaf ? ' · ' + t(a.stilzwijgen ? 'lidm.rol.stilzwijgendVanaf' : 'lidm.rol.herinneringVanaf', { datum: datum(r.stilzwijgend_vanaf) }) : '';
    const namens = r.namens_bond ? ' · ' + t('lidm.rol.namens') : '';
    const kleur = r.status === 'akkoord' ? 'var(--green)' : r.status === 'bezwaar' ? 'var(--red)' : 'var(--text-3)';
    const kan = a.status === 'open' && !a.geescaleerd && r.status === 'wacht' && r.kan;
    return `<div class="org-row" style="align-items:center;flex-wrap:wrap">
      <i class="ti ti-${ROL_ICOON[r.status]}" style="color:${kleur}" aria-hidden="true"></i>
      <div style="flex:1;min-width:200px;font-size:13px">${esc(t('lidm.rol.' + r.rol))}
        <span style="font-size:11px;color:var(--text-3)">${esc(t('lidm.rolstatus.' + r.status) + stil + namens)}</span>
        ${r.toelichting ? `<div style="font-size:11px;color:var(--text-2)">“${esc(r.toelichting)}”</div>` : ''}</div>
      ${kan ? `${knop('besluit', 'check', t('lidm.knop.akkoord'), 'btn-primary', `data-actie-id="${esc(a.actie_id)}" data-rol="${esc(r.rol)}" data-akkoord="1"`)}
        ${knop('besluit', 'x', t('lidm.knop.bezwaar'), 'btn-ghost', `data-actie-id="${esc(a.actie_id)}" data-rol="${esc(r.rol)}" data-akkoord=""`)}` : ''}
    </div>`;
  }).join('');
  const waar = [a.van_club_naam ? t('lidm.van', { club: a.van_club_naam }) : '', a.naar_club_naam ? t('lidm.naar', { club: a.naar_club_naam }) : '',
    t('lidm.per', { datum: datum(a.datum) })].filter(Boolean).join(' · ');
  return `<div style="border:1px solid var(--border);border-radius:var(--radius);padding:12px 14px;margin:10px 0" data-lm-kaart="${esc(a.actie_id)}">
    <div style="display:flex;justify-content:space-between;gap:8px;flex-wrap:wrap;align-items:flex-start">
      <div><div style="font-size:13px;font-weight:600">${esc(t('lidm.actie.' + a.actie))}: ${esc(a.persoon_naam || '')}</div>
        <div style="font-size:11px;color:var(--text-3);margin-top:2px">${esc(waar)}</div></div>
      <span class="badge ${BADGE[a.status] || 'badge-grey'}">${esc(t('lidm.status.' + a.status))}</span>
    </div>
    ${a.status === 'akkoord' ? klein(t('lidm.wacht.datum', { datum: datum(a.datum) })) : ''}
    ${a.status === 'open' && !a.geescaleerd && !a.bond_taak_sinds ? klein(t('lidm.termijn', { datum: datum(a.termijn_tot) })) : ''}
    ${a.geescaleerd && a.status === 'open' ? `<div class="banner banner-amber"><i class="ti ti-scale"></i><span>${esc(t('lidm.escalatie'))}</span></div>` : ''}
    ${a.bond_taak_sinds && !a.geescaleerd && a.status === 'open' ? `<div class="banner banner-amber" data-lm-taak><i class="ti ti-bell-ringing"></i><span>${esc(t('lidm.bondtaak'))}</span></div>` : ''}
    <div style="margin-top:6px">${rollen}</div>
    ${a.bond_kan_besluiten ? `<div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:8px">
      ${knop('bond', 'gavel', t('lidm.knop.doorzetten'), 'btn-primary', `data-actie-id="${esc(a.actie_id)}" data-doorzetten="1" data-taak="${a.geescaleerd ? '' : '1'}"`)}
      ${knop('bond', 'ban', t('lidm.knop.afwijzen'), 'btn-default', `data-actie-id="${esc(a.actie_id)}" data-doorzetten="" data-taak="${a.geescaleerd ? '' : '1'}"`)}</div>` : ''}
    ${a.kan_intrekken ? `<div style="margin-top:8px">${knop('intrek', 'arrow-back-up', t('lidm.knop.intrekken'), 'btn-ghost', `data-actie-id="${esc(a.actie_id)}"`)}</div>` : ''}
  </div>`;
}

// Een klik op een knop van de kaart. Roept `klaar` aan na een geslaagde handeling.
export async function behandelLm(k, client, klaar) {
  const a = k.dataset.lm;
  const id = k.dataset.actieId;
  if (a === 'besluit') {
    const akkoord = !!k.dataset.akkoord;
    let toelichting = null;
    if (!akkoord) {
      toelichting = await vraagToelichting({ titel: t('lidm.bezwaar.titel'), uitleg: t('lidm.bezwaar.uitleg'),
        label: t('lidm.bezwaar.veld'), knopTekst: t('lidm.knop.bezwaar') });
      if (!toelichting) return;
    }
    const { error } = await client.rpc('lidmaatschap_besluit', { p_actie: id, p_rol: k.dataset.rol, p_akkoord: akkoord, p_toelichting: toelichting });
    if (error) { toast(lidmFout(error), 'error'); return; }
    toast(t('lidm.besloten'), 'success');
    return klaar();
  }
  if (a === 'bond') {
    const doorzetten = !!k.dataset.doorzetten;
    const toelichting = await vraagToelichting({ titel: t('lidm.bond.titel'), uitleg: t(k.dataset.taak ? 'lidm.bond.uitlegTaak' : 'lidm.bond.uitleg'),
      label: t('lidm.bond.veld'), knopTekst: t(doorzetten ? 'lidm.knop.doorzetten' : 'lidm.knop.afwijzen') });
    if (!toelichting) return;
    const { error } = await client.rpc('lidmaatschap_bond_besluit', { p_actie: id, p_doorzetten: doorzetten, p_toelichting: toelichting });
    if (error) { toast(lidmFout(error), 'error'); return; }
    toast(t('lidm.besloten'), 'success');
    return klaar();
  }
  if (a === 'intrek') {
    const { error } = await client.rpc('lidmaatschap_wijziging_intrekken', { p_actie: id });
    if (error) { toast(lidmFout(error), 'error'); return; }
    toast(t('lidm.ingetrokken'), 'success');
    return klaar();
  }
  if (a === 'wijzig') {
    if (await vraagWijziging(client, k.dataset.relation, k.dataset.soort, {
      toelichtingVerplicht: !!k.dataset.verplicht, als: k.dataset.als || null, stilzwijgen: !!k.dataset.stil })) return klaar();
  }
}

// De tekst van een regel in het verzoek die door het systeem is gezet (meta.actie).
export function lidmLogTekst(meta, wie) {
  const hoofd = tekst => tekst.charAt(0).toUpperCase() + tekst.slice(1);
  if (meta.bond_besluit) return hoofd(t('lidm.log.bond.' + meta.bond_besluit, { partij: wie }));
  if (meta.herinnering) return hoofd(t('lidm.log.herinnering', { rol: t('lidm.rol.' + meta.rol) }));
  if (meta.rol) {
    return hoofd(t(meta.akkoord ? 'lidm.log.rolakkoord' : 'lidm.log.bezwaar', { partij: wie, rol: t('lidm.rol.' + meta.rol) })
      + (meta.stilzwijgend ? ' ' + t('lidm.log.stilzwijgend') : '') + (meta.namens ? ' ' + t('lidm.log.namens') : ''));
  }
  return hoofd(t('lidm.log.' + (meta.uitkomst || 'aangevraagd'), { partij: wie, datum: datum(meta.datum), naar: meta.naar || '', reden: meta.reden ? t('lidm.reden.' + meta.reden) : '' }).trim());
}

// ── Eigen omgeving van een lid ─────────────────────────────────────────────
export async function toonLidmaatschap(el, client) {
  const [lm, ac] = await Promise.all([client.rpc('lidmaatschap_mijn'), client.rpc('lidmaatschap_acties_lijst')]);
  if (lm.error || !(lm.data || []).length) { el.innerHTML = ''; el.hidden = true; return false; }
  el.hidden = false;
  const acties = ac.error ? [] : ac.data || [];
  const mijnPersonen = new Set(lm.data.map(r => r.person_id));
  const eigen = acties.filter(a => mijnPersonen.has(a.person_id));
  const open = eigen.filter(a => a.status === 'open' || a.status === 'akkoord');
  const klaar = eigen.filter(a => !(a.status === 'open' || a.status === 'akkoord')).slice(0, 3);

  const kaarten = lm.data.map(r => {
    const lopend = !!r.lopende_actie;
    return `<div class="org-row" style="align-items:flex-start;flex-wrap:wrap">
      <div style="flex:1;min-width:220px">
        <div style="font-size:13px;font-weight:600">${esc(r.persoon_naam)} · ${esc(r.bond_naam)}</div>
        <div style="font-size:12px;color:var(--text-3);margin-top:2px">
          ${esc(r.club_naam ? t('lidm.club', { club: r.club_naam }) : t('lidm.geenClub'))}
          ${r.vrijstelling ? ' · ' + esc(t('leden.club.vrijstelling.' + r.vrijstelling)) : ''}
          ${r.starts_on ? ' · ' + esc(t('lidm.sinds', { datum: datum(r.starts_on) })) : ''}
          ${r.ends_on ? ' · ' + esc(t('lidm.eindigt', { datum: datum(r.ends_on) })) : ''}</div>
        ${r.overgang_tot ? `<div class="banner banner-amber" style="margin-top:8px"><i class="ti ti-clock-exclamation"></i><span>${esc(t('lidm.overgang', { datum: datum(r.overgang_tot) }))}</span></div>` : ''}
      </div>
      <div style="display:flex;gap:6px;flex-wrap:wrap">
        ${lopend ? `<span style="font-size:12px;color:var(--text-3)">${esc(t('lidm.lopend'))}</span>` : `
          ${r.club_register_id && !r.vrijstelling ? knop('wijzig', 'arrows-exchange', t('lidm.knop.overstappen'), 'btn-primary', `data-relation="${esc(r.relation_id)}" data-soort="overstap"${stilAttr(r)}`) : ''}
          ${r.club_register_id && !r.vrijstelling ? knop('wijzig', 'plus', t('lidm.knop.tweede'), 'btn-default', `data-relation="${esc(r.relation_id)}" data-soort="tweede_club"`) : ''}
          ${knop('wijzig', 'door-exit', t('lidm.knop.opzeggen'), 'btn-ghost', `data-relation="${esc(r.relation_id)}" data-soort="opzegging"${stilAttr(r)}`)}`}
      </div></div>`;
  }).join('');

  el.innerHTML = `<h3 style="margin:0">${esc(t('lidm.titel'))}</h3>
    <div class="settings-desc">${esc(t('lidm.uitleg'))}</div>
    ${kaarten}
    ${open.map(actieKaartHtml).join('')}
    ${klaar.length ? `<div class="section-title" style="margin-top:12px"><i class="ti ti-circle-check"></i> ${esc(t('lidm.sectie.afgerond'))}</div>${klaar.map(actieKaartHtml).join('')}` : ''}`;

  const opnieuw = () => toonLidmaatschap(el, client);
  el.onclick = e => {
    const k = e.target.closest('[data-lm]');
    if (k && !k.disabled) behandelLm(k, client, opnieuw);
  };
  return true;
}
